export default {"src":"/_next/static/media/biceps.4dda5170.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};